export default __webpack_public_path__ + "static/media/ExpressIT.f4c762b5.png";